// ======================================================
// ✅ Componente: ErrorBoundary – Evalúa Salud IPS
// Autor: Breyner Javier Montalvo
// Descripción: Captura errores de renderizado en la UI
// y muestra un mensaje institucional de respaldo.
// ======================================================

import React from "react";
import PropTypes from "prop-types";
import "../styles/ErrorBoundary.css";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tieneError: false, mensaje: "" };
  }

  static getDerivedStateFromError(error) {
    return { tieneError: true, mensaje: error.message };
  }

  componentDidCatch(error, info) {
    console.error("🧨 Error capturado en ErrorBoundary:", error, info);
  }

  manejarRecarga = () => {
    window.location.reload();
  };

  render() {
    const { tieneError, mensaje } = this.state;
    if (tieneError) {
      return (
        <div className="error-boundary" role="alert">
          <div className="error-box">
            <h2>⚠ Ha ocurrido un error inesperado</h2>
            <p>
              El sistema encontró un problema al renderizar esta sección.
              <br />
              Puedes intentar recargar la página o volver al inicio.
            </p>

            <div className="error-actions">
              <button
                type="button"
                onClick={this.manejarRecarga}
                className="btn-reload"
              >
                🔄 Recargar
              </button>
              <a href="/" className="btn-home">
                🏠 Ir al inicio
              </a>
            </div>

            <details className="error-details">
              <summary>Detalles técnicos</summary>
              <pre>{mensaje}</pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};
